import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Alert } from "react-bootstrap";
import * as userActions from "../../actions/userActions";

import LoginForm from "./LoginForm";

class LoginPage extends Component {
  handleSave = (user) => {
    this.props.actions.loginUser(user);
  };

  render() {
    const { auth, savingUser } = this.props;

    return (
      <div className="login-page">
        {auth.resetSent && <AlertMessage />}
        <LoginForm onSave={this.handleSave} saving={savingUser} />
      </div>
    );
  }
}

const AlertMessage = () => (
  <Alert bsStyle="success" className="text-center">
    <strong>Password Reset Sent!</strong>
    <p>
      Please check for an email at the address you provided with a link to reset
      your account password.
    </p>
  </Alert>
);

LoginPage.propTypes = {
  actions: PropTypes.object,
  auth: PropTypes.object,
  savingUser: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state,
    auth: state.reducers.auth,
    savingUser: state.reducers.savingUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...userActions }, dispatch)
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(LoginPage)
);
